
/*
|--------------------------------------------------------------------------
| Enregistrements des composants
|--------------------------------------------------------------------------
|
| Les composants enregistrer ici doivent service à la gestion de la page /dl
| ou des espaces téléchargements des sites statiques PC SOFT
*/
import DlComponent from "./dl-component"
window.customElements.define('dl-component', DlComponent)
